import React, { useState } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Card } from "@mui/material";
import FileUploader from "../../../FileUploader";
import { endpoints } from "../../../../services/apiurl";
import Input from "../../../UI/Input/Input";
import PageTitle from "../../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import TextAreaInput from "../../../UI/Input/TextAreaInput";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Box from '@mui/material/Box';
const AddRestSection = () => {
  const [fileDataURL, setFileDataURL] = useState('');
  const [linkFile, setlinkFile] = useState(null);

  const [loading, setloading] = useState(false);

  const [showapp, setShowapp] = useState(0);
  const [showweb, setShowweb] = useState(0);
  const [show_contact_form, setShow_contact_formb] = useState(0);
  const [show_bent_popup, setShow_bent_popup] = useState(0);
  let history = useHistory();
  let { restro_id } = useParams();
  const [cat, setCat] = useState({
    name: "",
    // icon: '',
    status: "",
    food_note: "",
    type: "",
    upload_type: "",
    video_link: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };

  const handleFileSelectSuccessPdf = (file) => {
    setlinkFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      setFileDataURL(e.target.result);
    };
    reader.readAsDataURL(file);
  };
  

  const { name, status, food_note, type, upload_type, video_link } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    //console.log(cat);
  };

  const setStatus = async (e, type) => {
    if (e.target.checked) {
      var status = 1;
    } else {
      var status = 0;
    }
    if (type == "app") {
      setShowapp(status);
    } else {
      setShowweb(status);
    }
  };

  const setContact = async (e) => {
    if (e.target.checked) {
      var status = 1;
    } else {
      var status = 0;
    }
    setShow_contact_formb(status);
  };

  const setBentPopup = async (e) => {
    if (e.target.checked) {
      var status = 1;
    } else {
      var status = 0;
    }
    setShow_bent_popup(status);
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    if (!selectedFile) {
      alert("Please select image");
      setloading(false);
      return false;
    }
    const formData = new FormData();
    formData.append("name", name);
    formData.append("food_note", food_note);

    formData.append("restro_id", restro_id);
    formData.append("icon", selectedFile);

    formData.append("type", type);
    formData.append("upload_type", upload_type);

    if (upload_type == 1) {
      formData.append("video_link", video_link);
    } else {
      formData.append("video_link", linkFile);
    }

    formData.append("status", status);
    formData.append("show_web", showweb);
    formData.append("show_app", showapp);
    formData.append("show_contact_form", show_contact_form);

    // console.log('ca', formData);
    try {
      const response = await axios.post(endpoints.addSection, formData);
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("Main Category Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during adding Main Category:", error);
      setloading(false);

      toast.error("Error during adding Main Category. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Main Category" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <TextAreaInput
              id="food_note"
              label="Food Note & Desc"
              name="food_note"
              place="Food Note & Desc"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={food_note}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Icon</label>
              <FileUploader
                onFileSelectSuccess={handleFileSelectSuccess}
                onFileSelectError={handleFileSelectError}
              />

              {selectedFile && (
                <div>
                  <p>Preview:</p>
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Selected icon"
                    height="200px"
                    width="200px"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Type</label>
              <select
                name="type"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Type</option>
                <option value="1">Text</option>
                <option value="2">PDF</option>
              </select>
            </div>
            {type == 2 && (
              <>
                <div className="col col-6">
                  <label>Upload Type</label>
                  <select
                    name="upload_type"
                    required
                    className="form-control"
                    onChange={(e) => onInputChange(e)}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Link</option>
                    <option value="2">Upload</option>
                  </select>
                </div>
                {upload_type == 2 ? (
                  <div className="col col-6">
                    <label>Pdf Upload</label>
                    <FileUploader
                     onFileSelectSuccess={handleFileSelectSuccessPdf}
                     onFileSelectError={({ error }) => alert(error)}
                    />
                     {linkFile && (
            <div>
             
              <Box>
              <embed src={fileDataURL} type="application/pdf" width="60%" height="300px" className="mt-3" />
            </Box>
            </div>
          )}
        </div>
                ) : (
                  upload_type != "" && (
                    <TextAreaInput
                      id="video_link"
                      label="Video Link"
                      name="video_link"
                      place="Video Link"
                      onChange={(e) => onInputChange(e)}
                      requiredInput="required"
                      value={video_link}
                      class="col col-6"
                    />
                  )
                )}
              </>
            )}
          </div>

          <div className="row">
            <div className="col col-6">
              <label>
                <input
                  type="checkbox"
                  checked={showapp == 1 ? true : false}
                  onChange={(e) => setStatus(e, "app")}
                />
                Status Show (App)
              </label>
            </div>

            <div className="col col-6">
              <label>
                <input
                  type="checkbox"
                  checked={showweb == 1 ? true : false}
                  onChange={(e) => setStatus(e, "web")}
                />
                Status Show (Web)
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <label>
                <input
                  type="checkbox"
                  checked={show_contact_form == 1 ? true : false}
                  onChange={(e) => setContact(e)}
                />
                Contact Form Show
              </label>
            </div>
            <div className="col col-6">
              <label>
                <input
                  type="checkbox"
                  checked={show_bent_popup == 1 ? true : false}
                  onChange={(e) => setBentPopup(e)}
                />
                Bentchair Popup Show
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddRestSection;
